// WordPress dependencies
// eslint-disable-next-line @wordpress/no-unsafe-wp-apis
import {
    __experimentalUnitControl as UnitControl,
    Button,
    ColorIndicator,
    PanelBody,
    PanelRow,
    RangeControl,
    SelectControl,
} from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import { useState } from "@wordpress/element";

// Internal dependencies
import ProFeatureControl from "../elements/pro-feature-control";
import { getNumberFromString, ucFirst } from "../../utils";
import ColorControl from "../control/color-control";
import GradientControl from "../control/gradient-control";

const coreAssets = window.COCA_BAIS_ASSETS;

export default (props) => {
    const [toggleOptions, updateToggleOptions] = useState({
        background_gradient_default: false,
        background_gradient_hover: false,
    });

    const getAttr = (attribute) => {
        const store = props.attributes;
        return !!store[attribute] ? store[attribute] : "";
    };

    const HandleBorderField = (
        <>
            <div className={"field-control field-inline"}>
                <span className={"field-control__label"}>{__("Border Style", "wp-before-after-image-slider")}</span>
                <div className={"fields-wrapper inline"}>
                    <SelectControl
                        value={props.attributes.handle_border_style}
                        onChange={(value) => props.updateAttributes({ handle_border_style: value })}
                        options={[].map.call(
                            ["none", "solid", "double", "dotted", "dashed", "groove"],
                            (borderType) => ({
                                // eslint-disable-next-line @wordpress/i18n-no-variables
                                label: __(ucFirst(borderType), "wp-before-after-image-slider"),
                                value: borderType,
                            }),
                        )}
                    />
                </div>
            </div>
            {props.attributes.handle_border_style !== "none" ? (
                <>
                    <div className={"field-control field-inline"}>
                        <span className={"field-control__label"}>
                            {__("Border Width", "wp-before-after-image-slider")}
                        </span>
                        <div className={"fields-wrapper inline"}>
                            <div
                                className={"group-field"}
                                style={{ width: "100%", display: "flex", gap: "10px", marginRight: "12px" }}
                            >
                                <UnitControl
                                    className="coca-unit-control"
                                    isPressEnterToChange
                                    onChange={(value) => props.updateAttributes({ handle_border_width: value })}
                                    value={getAttr("handle_border_width")}
                                />
                                <RangeControl
                                    onChange={(value) => props.updateAttributes({ handle_border_width: value })}
                                    max={100}
                                    min={0}
                                    step={1}
                                    trackColor="#4A25E1"
                                    railColor="#603CFF7A"
                                    allowReset={true}
                                    withInputField={false}
                                    value={getNumberFromString(getAttr("handle_border_width"))}
                                />
                            </div>
                        </div>
                    </div>
                    <div className={"field-control field-inline"}>
                        <span className={"field-control__label"}>
                            {__("Border Color", "wp-before-after-image-slider")}
                        </span>
                        <div className={"fields-wrapper inline"}>
                            <div className={"field"}>
                                {ColorControl({
                                    props,
                                    attribute: "handle_border_color_normal",
                                    labelText: __("Default", "wp-before-after-image-slider"),
                                    resetText: __("Clear", "wp-before-after-image-slider"),
                                })}
                            </div>
                            <div className={"field"}>
                                {ColorControl({
                                    props,
                                    attribute: "handle_border_color_hover",
                                    labelText: __("Hover", "wp-before-after-image-slider"),
                                    resetText: __("Clear", "wp-before-after-image-slider"),
                                })}
                            </div>
                        </div>
                    </div>
                </>
            ) : null}
        </>
    );

    return (
        <PanelBody
            title={
                <div className="components-panel__body-title__content">
                    {__("Handle", "wp-before-after-image-slider")}{" "}
                    {!!props.proFeatureEnabled ? null : (
                        <a
                            href="https://codecanel.com/wp-before-after-image-slider/#product-pricing"
                            target="_blank"
                            style={{ marginTop: "6px" }}
                            title="Buy Pro"
                            onClick={function (e) {
                                e.stopPropagation();
                            }}
                        >
                            <img src={coreAssets.icons.premium} alt="Premium Icon" />
                        </a>
                    )}
                </div>
            }
            initialOpen={false}
            opened={props.attributes.handle_panel_open}
            onToggle={() => props.updateAttributes({ handle_panel_open: !props.attributes.handle_panel_open })}
        >
            <PanelRow>
                <ProFeatureControl {...props} value={"handle_icon_color_normal"}>
                    {props.attributes.slider_template !== "style07" && (
                        <div className={"field-control field-inline"}>
                            <span className="field-control__label">
                                {__("Arrow Color", "wp-before-after-image-slider")}
                            </span>
                            <div className={"fields-wrapper inline"}>
                                <div className={"field"}>
                                    {ColorControl({
                                        props,
                                        attribute: "handle_icon_color_normal",
                                        labelText: __("Default", "wp-before-after-image-slider"),
                                        resetText: __("Clear", "wp-before-after-image-slider"),
                                    })}
                                </div>
                                <div className={"field"}>
                                    {ColorControl({
                                        props,
                                        attribute: "handle_icon_color_hover",
                                        labelText: __("Hover", "wp-before-after-image-slider"),
                                        resetText: __("Clear", "wp-before-after-image-slider"),
                                    })}
                                </div>
                            </div>
                        </div>
                    )}
                    {!["style03", "style04", "style06"].includes(props.attributes.slider_template) && (
                        <>
                            <div className={"field-control field-inline"}>
                                <span className="field-control__label">
                                    {__("Background Color", "wp-before-after-image-slider")}
                                </span>
                                <div className={"fields-wrapper inline"}>
                                    <div className={"field"}>
                                        {ColorControl({
                                            props,
                                            attribute: "handle_background_color_normal",
                                            labelText: __("Default", "wp-before-after-image-slider"),
                                            resetText: __("Clear", "wp-before-after-image-slider"),
                                        })}
                                    </div>
                                    <div className={"field"}>
                                        {ColorControl({
                                            props,
                                            attribute: "handle_background_color_hover",
                                            labelText: __("Hover", "wp-before-after-image-slider"),
                                            resetText: __("Clear", "wp-before-after-image-slider"),
                                        })}
                                    </div>
                                </div>
                            </div>
                            <div className={"field-control field-inline"}>
                                <span className="field-control__label">
                                    {__("Background Gradient", "wp-before-after-image-slider")}
                                </span>
                                <div className={"fields-wrapper inline"}>
                                    <div className={"field"}>
                                        {GradientControl({
                                            props,
                                            attribute: "handle_background_gradient_normal",
                                            defaultValue: getAttr("handle_background_gradient_normal"),
                                            labelText: __("Default", "wp-before-after-image-slider"),
                                        })}
                                    </div>
                                    <div className={"field"}>
                                        {GradientControl({
                                            props,
                                            attribute: "handle_background_gradient_hover",
                                            defaultValue: getAttr("handle_background_gradient_hover"),
                                            labelText: __("Hover", "wp-before-after-image-slider"),
                                        })}
                                    </div>
                                </div>
                            </div>
                        </>
                    )}

                    {!["style02", "style04", "style07"].includes(props.attributes.slider_template) && HandleBorderField}
                </ProFeatureControl>
            </PanelRow>
        </PanelBody>
    );
};
